export const CONTACT_US_GROUP_LINKS = {
  BASE: "/contact-us",
};
